<template>
	<v-container fluid>
		<v-row class="my-2">
			<v-tabs v-model="tab" height="35"
				background-color="primary"
				hide-slider
				fixed-tabs
				dark>
				<v-tab to="/customer/decisions/pm" ripple
					class="text-capitalize">
					Product management
				</v-tab>
				<v-tab :to="link(item)" ripple
					class="text-capitalize"
					v-for="item in items"
					:key="item"
				>
					{{ item }}
				</v-tab>
			</v-tabs>
		</v-row>
		<v-row class="caption font-weight-bold">
			<span class="ml-4">company: {{company}}</span>
			<span class="ml-4">current round: {{round}}</span>
			<span class="ml-4">year: {{currentYear}}</span>
		</v-row>
		<v-divider class="mt-8"></v-divider>

		<v-tabs-items v-model="tab" continuous>
			<v-tab-item value="/customer/decisions/pm">
				<product-management
					:company="company"
					:gameId="gameId"
					:round="round"
				></product-management>
			</v-tab-item>
			<v-tab-item value="/customer/decisions/sales">
				<sales
					:company="company"
					:gameId="gameId"
					:round="round">
				</sales>
			</v-tab-item>
			<v-tab-item value="/customer/decisions/retail">
				<retail
					:company="company"
					:gameId="gameId"
					:round="round">
				</retail>
			</v-tab-item>
			<v-tab-item value="/customer/decisions/promotion">
				<promotion
					:company="company"
					:gameId="gameId"
					:round="round">
				</promotion>
			</v-tab-item>
			<v-tab-item value="/customer/decisions/consultancy">
				<consultancy
					:company="company"
					:gameId="gameId"
					:round="round">
				</consultancy>
			</v-tab-item>
			<!-- <v-tab-item value="/customer/decisions/finance">
				<finance></finance>
			</v-tab-item> -->
		</v-tabs-items>
	</v-container>
</template>
<script>
	import ProductManagement from '../components/decisions/ProductManagement.vue'
	import Sales from '../components/decisions/Sales.vue'
	import Consultancy from '../components/decisions/Consultancy.vue'
	import Retail from '../components/decisions/Retail.vue'
	import Promotion from '../components/decisions/Promotion.vue'
	//import Finance from '../components/decisions/Finance.vue'

	export default {
		data () {
			return {
				tab: 0,
				items: ['Sales','Retail','Promotion','Consultancy']
			}
		},
		computed: {
			company () {
				return this.$store.getters.company
			},
			currentYear () {
				return this.$store.getters.currentYear
			},
			round () {
				return this.$store.getters.currentRound
			},
			gameId () {
				return this.$store.getters.gameId
			}
		},
		methods: {
			link (item) {
				return `/customer/decisions/${item.toLowerCase()}`
			}
		},
		components: {
			ProductManagement,
			Sales,
			Retail,
			Promotion,
			Consultancy, 
			//Finance
		}
	}
</script>